import React from 'react';
import { Item } from '../../types/Item';

interface PriceSummaryProps {
  items: Item[];
  subtotal: number;
  discount: number;
  discountAmount: number;
  totalPrice: number;
  notes?: string;
  onDiscountChange?: (discount: number) => void;
  showDiscount?: boolean;
}

export const PriceSummary: React.FC<PriceSummaryProps> = ({ 
  items, 
  subtotal, 
  discount, 
  discountAmount, 
  totalPrice, 
  notes = '', 
  onDiscountChange,
  showDiscount = false
}) => {
  return (
    <div className="discount-section">
      {showDiscount && (
        <div className="discount-header">
          <h4>Klantenkorting</h4>
          {onDiscountChange && (
            <div className="discount-input">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={discount === 0 ? '' : discount}
                onChange={(e) => onDiscountChange(parseFloat(e.target.value) || 0)}
                placeholder="0"
                className="discount-field"
              />
              <span className="discount-percentage">%</span>
            </div>
          )}
        </div>
      )}
      
      <div className="price-totals">
        <div className="price-line">
          <span>{items.length} items</span>
          <span>€{subtotal.toFixed(2)}</span>
        </div>
        {showDiscount && discount > 0 && (
          <div className="price-line discount-line">
            <span>Korting ({discount}%):</span>
            <span>-€{discountAmount.toFixed(2)}</span>
          </div>
        )}
        <div className="price-line total-line">
          <span><strong>Totaal:</strong></span>
          <span><strong>€{totalPrice.toFixed(2)}</strong></span>
        </div>
      </div>
    </div>
  );
};
